import { reactive, ref, shallowReactive, shallowRef } from "vue";
import { definePayloadReviver, getNuxtClientPayload } from "#app/composables/payload";
import { createError } from "#app/composables/error";
import { defineNuxtPlugin } from "#app/nuxt";
const revivers = {
  NuxtError: (data) => createError(data),
  EmptyShallowRef: (data) => shallowRef(data === "_" ? void 0 : data === "0n" ? 0n : JSON.parse(data)),
  EmptyRef: (data) => ref(data === "_" ? void 0 : data === "0n" ? 0n : JSON.parse(data)),
  ShallowRef: (data) => shallowRef(data),
  ShallowReactive: (data) => shallowReactive(data),
  Ref: (data) => ref(data),
  Reactive: (data) => reactive(data)
};
export default defineNuxtPlugin({
  name: "nuxt:revive-payload:client",
  order: -30,
  async setup(nuxtApp) {
    for (const reviver in revivers) {
      definePayloadReviver(reviver, revivers[reviver]);
    }
    Object.assign(nuxtApp.payload, await nuxtApp.runWithContext(getNuxtClientPayload));
    window.__NUXT__ = nuxtApp.payload;
  }
});
